import { Button, Modal } from 'react-bootstrap';

// v6 stepper forms (finance_module_stepper_forms_and_pending_items.md, Part D / §D4).
//
// One shared preview popup for the wizard Review step - "Back to edit" / primary submit. Listing
// wizards render the listing card + key specs here; booking wizards render the order summary +
// price breakdown + address + policy (the generalised AddressConfirmModal content).
export default function PreviewModal({
  show,
  onHide,
  onSubmit,
  submitting = false,
  submitLabel = 'Submit',
  title = 'Preview',
  backLabel = 'Back to edit',
  disableSubmit = false,
  children,
}) {
  return (
    <Modal show={show} onHide={onHide} fullscreen="sm-down" centered size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title as="h5">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide} disabled={submitting}>
          {backLabel}
        </Button>
        <Button
          variant="primary"
          onClick={() => onSubmit && onSubmit()}
          disabled={submitting || disableSubmit}
        >
          {submitting ? 'Submitting…' : submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
